"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".popup-title[_ngcontent-%COMP%]{color:var(--color-white);font-size:var(--font-medium);font-weight:var(--font-weight-bold)}"];
exports.styles = styles;
